// frontend/src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme';
import CssBaseline from '@mui/material/CssBaseline';
import { SnackbarProvider } from 'notistack';
import ColdStartLoader from './components/ColdStartLoader';

// Add a class to the HTML while fonts are loading
document.documentElement.classList.add('fonts-loading');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <ColdStartLoader>
          <AuthProvider>
            <SnackbarProvider
               maxSnack={3}
               anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
               autoHideDuration={4000}
            >
              <App />
            </SnackbarProvider>
          </AuthProvider>
        </ColdStartLoader>
      </ThemeProvider>
    </Router>
  </React.StrictMode>
);

reportWebVitals();
